import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API_URL } from '../../lib/api';
import { eur } from './api';

const ITEMS = [['en_attente', 'Scannées en attente', 'text-amber-700'], ['preparees', 'Préparées (secrétariat)', 'text-sky-700'],
    ['rattachees', 'Déjà traitées / rattachées', 'text-emerald-700'], ['ecartees', 'Écartées / archivées', 'text-gray-500']];

// Factures scannées du mois : toujours séparées des montants réellement comptabilisés
export function MonthInvoiceKpis({ mois, onOpen }) {
    const [d, setD] = useState(null);
    const req = useRef(0);
    useEffect(() => {
        const my = ++req.current;
        setD(null);
        axios.get(`${API_URL}/api/invoice-review/resume-mois`, { withCredentials: true, params: mois ? { mois } : {} })
            .then(r => { if (my === req.current) setD(r.data); }).catch(() => { if (my === req.current) setD(null); });
    }, [mois]);
    if (!d) return null;
    return (
        <div className="mb-6 rounded-xl border border-dashed border-gray-300 bg-white/70 p-3" data-testid="month-invoice-kpis">
            <p className="text-[11px] uppercase tracking-wider text-gray-400 mb-2">Factures scannées {mois ? 'du mois' : '(tous les mois)'} — non comptées dans les frais tant qu'elles ne sont pas validées</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                {ITEMS.map(([k, l, c]) => (
                    <button key={k} onClick={onOpen} className="text-left rounded-lg px-3 py-2 hover:bg-gray-50 transition-colors" data-testid={`month-invoice-kpi-${k}`}>
                        <p className="text-[11px] text-gray-500">{l}</p>
                        <p className={`text-lg font-semibold ${c}`}>{d[k].nb}</p>
                        <p className="text-[11px] text-gray-400 font-mono">{eur(d[k].ttc)} TTC indicatif</p>
                    </button>
                ))}
            </div>
        </div>
    );
}
